import { render, staticRenderFns } from "./ChangeGate.vue?vue&type=template&id=cd7a697a&"
import script from "./ChangeGate.vue?vue&type=script&lang=js&"
export * from "./ChangeGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports